<template>
    <tw-modal :show="modelValue" :icon="icon" :title="title" :subtitle="subtitle" @close="$emit('update:modelValue', false)">
        <tw-form :id="id" :modelValue="form" @update:modelValue="$emit('update:form', $event)" @onSubmit="$emit('onSubmit', $event)" v-slot:default="props" :action="action" :method="method">
            <slot v-bind:="props" />
            <slot name="action">
                <div v-if="button" class="p-4 pt-0 mt-5 sm:mt-6 flex justify-end">
                    <tw-button type="submit" :disabled="!props.valid" v-text="button" class="w-full" />
                </div>
            </slot>
        </tw-form>
    </tw-modal>
</template>
<script>
import { DialogTitle } from '@headlessui/vue'

export default {
    props: {
        id: String,
        modelValue: Boolean,
        icon: {},
        title: String,
        subtitle: String,
        button: String,
        form: {},
        action: String,
        method: String,
    },
    components: {
        DialogTitle
    }
}

</script>
